import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router';
import { getSadirInvitationDetails , editSadirInvitationDetails , fetchInvitationDetails } from '../../apiCall';
import { QrReader } from 'react-qr-reader';


function VerifyPassengers() {
    const { id, type, date } = useParams();
    const [passengers, setPassengers] = useState([]);
    const [passenger, setPassenger] = useState();
    const [travle, setTravle] = useState([]);
    const [orbit, setOrbit] = useState([]);
    const [sumAmountOfPassengers, setSumAmountOfPassengers] = useState(0);
    const [qrScannerOpen, setQrScannerOpen] = useState(false);
    const [existsPassengerQrScannerOpen, setExistsPassengerQrScannerOpen] = useState(false);
    const [error, setError] = useState(false);
    const [scannedData, setScannedData] = useState(null);
    const [searchQuery, setSearchQuery] = useState(""); 

    const constraints = {
        facingMode: 'environment', // This will use the rear camera
      };
      const [facingMode, setFacingMode] = useState('environment'); // 'user' for front camera, 'environment' for back camera


    useEffect(()=>{
        getInvitation();
    //   }, [travle.passengers , passengers])
      }, [])

    const getInvitation = () => {
        getSadirInvitationDetails(id, type, date, function(response) {
            // console.log(response.result);
            if(response.result[0].passengers){
                // console.log(response.result[0].passengers);
             setPassengers(response.result[0].passengers) ;
             setTravle(response.result[0])  
             setOrbit(response.result[0].orbit) 
             let totalPassengers = 0;
             response.result[0].passengers.forEach(passenger => {
                 totalPassengers += passenger.amountOfPassengers;
             });
             setSumAmountOfPassengers(totalPassengers)
            }            
        });
    }

    const handlePassengerSelect = (index) => {
        const updatedPassengers = [...passengers];
        updatedPassengers[index] = {
            ...updatedPassengers[index],
            isQRCodeScanned: !updatedPassengers[index].isQRCodeScanned
        };
    
        const updatedTravel = { ...travle, passengers: updatedPassengers };
    
        setPassengers(updatedPassengers);
        setTravle(updatedTravel);
    
        editSadirInvitationDetails(updatedTravel, function(response) {
            console.log(updatedTravel);          
        });
    }

    const handleOpenQrScanner = () => {
        setQrScannerOpen(true);
    };

    const handleOpenExistsPassengerQrScanner = () => {
        setExistsPassengerQrScannerOpen(true);
    };

    const handleScan = (data) => {
        if (data) {
            console.log(data.text)
         const dataArray = data.text.split(",");
          setScannedData(dataArray);
          setQrScannerOpen(false)
        }
      };

      const existsPassengerHandleScan = (data) => {
        if (data) {
            console.log(data.text)
            console.log(travle.orbit.code)
            const url = data.text ;

            const matches = url.match(/verifyInvite\/(.*?)\/sadir\/(.*?)$/);
            const id = matches && matches[1];
            const date = matches && matches[2];
            console.log(id , date)

            if(travle.orbit.code == 'ka'){
                updateTravel(id , date)
            }else{
                updateBackTravel(id , date) 
            }

            setExistsPassengerQrScannerOpen(false)
        }
      };

      const updateTravel = (id , date) => {
        fetchInvitationDetails(id , 'sadir' , date , function(response){
            if(response.result.orbit.id !== travle.orbit.id){
                setError(true)
            }else{
            const passenger = response.result.passengers.find(
                (pass) => pass.connectedCustomerTravel === id
              );
              console.log(passenger)
              setPassenger(passenger)    
            }
            
        });
      }

      const updateBackTravel = (id , date) => {
        fetchInvitationDetails(id , 'sadir' , date , function(response){
            const passenger = response.result.passengers.find(
                (pass) => pass.connectedCustomerTravel === id
              );
              console.log(passenger)
              console.log(passenger.name)  
              passengers.map(testPassenger => {
              if (testPassenger.name === passenger.name) {
                  console.log(testPassenger) 
                  setPassenger(testPassenger)
             }
            });
              
        });
      }

      const createPassengerObject = () => {
        const passenger = {
            agent: createAgentObject(),
            agentApprove : null ,
            agentsCompanyAppUID : null ,
            agentsCompanyEmail : null , 
            amountOfPassengers: 1,
            createdBy : {} , 
            id: scannedData[1],
            localID: scannedData[1],
            travelsID : travle.id , 
            connectedCustomerTravel : travle.id , 
            name: scannedData[2],
            englishName: scannedData[2],
            phone: '',
            notes: '',
            money: createMoney(),
            linkType: scannedData[0],
            customerDetails: {},
            agentApprove :  true  , 
            isQRCodeScanned: true , 
            type : 'sadir' , 
            startLocation : null 
        };
        console.log(passenger)
        travle.passengers.push(passenger);
        console.log(travle)
        updateSadir(travle)
        return passenger;
    };

    const updateSadir = (travel) => {
        editSadirInvitationDetails(travel, function(response) {
            console.log(travel);
            alert("הנוסע נוסף בהצלחה"); 
            setScannedData(null)
            getInvitation();
        });
    };

    const approveAndUpdate = () => {
        const updatedPassengers = passengers.map(testPassenger => {
            if (testPassenger.id === passenger.id) {
                return { ...passenger, isQRCodeScanned: true };
            }
            return testPassenger;
        });
        
        console.log(updatedPassengers);
        const updatedTravel = { ...travle, passengers: updatedPassengers };
        setTravle(updatedTravel);
        editSadirInvitationDetails(updatedTravel, function(response) {
            console.log(updatedTravel); 
            alert("הנוסע אושר בהצלחה"); 
            getInvitation();  
            setPassenger();     
        });
    
        return updatedPassengers;
    };
    




    const createAgentObject = () => {
        const newAgent =  {
          id: '',
          active: false,
          adress: '',
          city: '',
          code: '',
          listPosition: 1,
          company: '',
          enFamilyName: '',
          enFirstName: '',
          familyName: '',
          firstName: scannedData[0],
          nameUk: '',
          phone1: '',
          phone2: '',
          phoneOffice: '',
          rank: '',
          autoCharge: null,
          agentAppUID: null,
          agentAppEmail: null,
          agentsCompanyAppUID: null,
          agentsCompanyEmail: null,
          pychWorker: false,
          selectable:false,
          notes: '',
          hideAgentPart: false,
        }
    
        return newAgent;
      }

      const createMoney = () => {
        const money =  {
          actualChargeAgent : 0 , 
          actualChargeDriver : 0 , 
          actualChargeDriverDate : '' , 
          actualChargePych : 0 , 
          agentPart : 0 , 
          agentPartPayed : [] , 
          allowMoneyReceivedFromDriver : true , 
          companyWorkerCharge : [] , 
          driverPart : 0 , 
          driverPartPayed : [] , 
          hotel : 0 , 
          isDriverUpdateMoneyReceived : false , 
          isFinalPrice : true  ,
          managementStatus : 'no' , 
          manegementAgentStatus : [] ,
          moneyReceivedFromAgent : 0 , 
          moneyReceivedFromDriver : 0 ,
          moneyReceivedPych : 0 , 
          needToChargeAgent : 0 ,
          needToChargeDriver : travle.money.price ,
          needToChargePych : 0 ,
          ourPart : 0 , 
          ourPartPayed : 0 ,
          price: travle.money.price,
        }
    
        return money;
      }


      const cancel = () => {
        setPassenger()
        setScannedData(null)
      };




  return (
    <div class="card summaryCard">
              <img style={{ margin: '0' , height :'100px' }} src="/pycBlueIogo.png" alt="pycBlueIogo" />
          {travle ?
        <div>
                <h6 className="headerBack" style={{textAlign : 'center'}}>פרטי נסיעה  </h6>
                <div className='parameter'>
                    <span>{travle.dateStartTraveling}</span>
                    <span style={{ fontWeight: 'bold' }}>  : תאריך </span>
                    </div>
                    <div className='parameter'>
                    <span>{travle.hourStartTraveling}</span>
                    <span style={{ fontWeight: 'bold' }}>  : שעה </span>
                    </div>
                    <div className='parameter'>
                    <span>{orbit.name}</span>
                    <span style={{ fontWeight: 'bold' }}>  : מסלול </span>
                    </div>
                    <div className='parameter'>
                    <span style={{ fontWeight: 'bold' , color : 'red' }}>{sumAmountOfPassengers}</span>
                    <span style={{ fontWeight: 'bold' }}>  : סה"כ נוסעים  </span>
                    </div>

        </div>
        : ""}  

{passengers ?
                <div style ={{ border : '1px solid black' , borderRadius : '10px' , padding : '10px' , marginTop : '10px'}}>
                    <h6 className="headerBack">רשימת נוסעים בנסיעה זו </h6>
                <input
                type="text"
                placeholder="חפש נוסע :"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                style={{padding: '5px' , borderRadius : '10px' , marginTop :'10px' ,marginBottom : '10px'}}
                />
                    <ul>
                        {passengers.map((passenger, index) => {
                            if (passenger.name.includes(searchQuery)) {
                                return (
                                    <li key={index}>
                                        <label>
                                            <input
                                                type="checkbox"
                                                checked={passenger.isQRCodeScanned}
                                                onChange={() => handlePassengerSelect(index)}
                                            />
                                            {passenger.name}  , 
                                            כמות : {passenger.amountOfPassengers}   
                                        </label>
                                    </li>
                                );
                            }
                            return null;
                        })}
                    </ul>
                </div>
                : ""}
    {error ? <>
        <p style={{color : 'red' ,fontWeight: 'bold' , fontSize : '30px' }}>נוסע זה עלה על קו שגוי</p>
     </>: <></>}

    <button className='verifyBtn' onClick={handleOpenExistsPassengerQrScanner} variant="contained">סרוק כדי לאשר נוסע</button>  
    <button className='verifyBtn' onClick={handleOpenQrScanner} variant="contained" style={{backgroundColor : '#fff200' , color : 'black'}}>סרוק כדי להוסיף נוסע שאינו ברשימה</button>  
    {qrScannerOpen && (
    <div className='qr-scanner-modal' style={{ width: '100%', height: '500px' }}>
    <QrReader
    delay={300}
    onError={(err) => console.error(err)}
    onResult={handleScan}
    style={{ width: '100%', height: '500px' }} 
    // facingMode={facingMode}
    facingMode="rear"
    constraints={constraints}
    />
    {/* {facingMode === 'user' ?      
    <button onClick={() => setFacingMode('environment')}>Switch to Back Camera</button>
    : 
    <button onClick={() => setFacingMode('user')}>Switch to Front Camera</button>
    } */}
    <button className='close-qrcode-scanner verifyBtn'  style={{ backgroundColor : 'red' , width : '70px'}}  onClick={() => setQrScannerOpen(false)}>סגור</button>
    </div>
     )}


   {existsPassengerQrScannerOpen && (
    <div className='qr-scanner-modal' style={{ width: '100%', height: '500px' }}>
    <QrReader
    delay={300}
    onError={(err) => console.error(err)}
    onResult={existsPassengerHandleScan}
    style={{ width: '100%', height: '500px' }} 
    facingMode="rear"
    constraints={constraints}
    />
    {/* {facingMode === 'user' ?      
    <button onClick={() => setFacingMode('environment')}>Switch to Back Camera</button>
    : 
    <button onClick={() => setFacingMode('user')}>Switch to Front Camera</button>
    } */}
    <button className='close-qrcode-scanner verifyBtn' style={{ backgroundColor : 'red' , width : '70px'}}  onClick={() => setExistsPassengerQrScannerOpen(false)}>סגור</button>
    </div>
     )}

     {scannedData ? <>
     <div style ={{ border : '1px solid black' , borderRadius : '10px' , padding : '7px' , marginTop : '10px'}}>
        <div className='parameter'>
         <span>{scannedData[2]}</span>
         <span style={{ fontWeight: 'bold' }}>  : שם </span>
         </div>
         <div className='parameter'>
         <span>{scannedData[0]}</span>
         <span style={{ fontWeight: 'bold' }}>  : חברה </span>
         </div>
         <div className='parameter'>
         <span>1</span>
         <span style={{ fontWeight: 'bold' }}>  : כמות </span>
         </div>
     <button className='verifyBtn' onClick={createPassengerObject} variant="contained"> הוסף נוסע זה  </button> 
     <button className='verifyBtn' onClick={cancel} variant="contained" style={{ backgroundColor : 'red'}}>    ביטול  </button>
     </div> 
     </>: <></>}

     {passenger ? <>
     <div style ={{ border : '1px solid black' , borderRadius : '10px' , padding : '7px' , marginTop : '10px'}}>
        <div className='parameter'>
         <span>{passenger.name}</span>
         <span style={{ fontWeight: 'bold' }}>  : שם </span>
         </div>
         <div className='parameter'>
         <span>{passenger.amountOfPassengers}</span>
         <span style={{ fontWeight: 'bold' }}>  : כמות </span>
         </div>
     <button className='verifyBtn' onClick={approveAndUpdate} variant="contained">  אשר נוסע זה  </button> 
     <button className='verifyBtn' onClick={cancel}  variant="contained" style={{ backgroundColor : 'red'}}>    ביטול  </button>
     </div> 
     </>: <></>}


 

</div>

  )
}

export default VerifyPassengers